import clsx from 'clsx';
import * as React from 'react';
import { textInputStyles } from './shared-input-styles';

/* -------------------------------------------------------------------------------------------------
 * StyledInput
 * -----------------------------------------------------------------------------------------------*/

type StyledInputElement = React.ElementRef<'input'>;
type StyledInputProps = React.ComponentPropsWithoutRef<'input'>;

// eslint-disable-next-line react-x/no-forward-ref -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it. (StyledInput is injected as react-phone-number-input's inputComponent and Headless UI's PopoverButton as=, so verify both third-party ref typings still accept it.)
const StyledInput = React.forwardRef<StyledInputElement, StyledInputProps>(
  ({ className: classNameProp, ...props }, forwardedRef) => {
    const className = clsx(textInputStyles, classNameProp);
    return <input {...props} className={className} ref={forwardedRef} />;
  },
);

StyledInput.displayName = 'StyledInput';

export { StyledInput };
